import { Icon } from "components/index";
import { FOLDER } from "icons";
import { useLocation, useNavigate } from "react-router-dom";

export default function FolderGridItem({ folder }) {
    if (!folder) return null;
    const location = useLocation();
    const navigate = useNavigate();

    const openFolder = () => {
        navigate(`${location.pathname}/${folder.id}`);
    };

    return (
        <div
            onDoubleClick={openFolder}
            className="flex flex-col border border-border group cursor-default select-none cursor-pointer"
        >
            <div className="aspect-square bg-muted relative">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300">
                    <Icon
                        icon="mdi:folder-open-outline"
                        className="size-32 text-gray-500/60 hidden group-hover:block opacity-0 group-hover:opacity-100"
                    />
                    <Icon
                        icon={FOLDER}
                        className="size-32 text-gray-500/60 group-hover:hidden"
                    />
                    <span className="text-xs text-gray-500/60 hidden group-hover:block opacity-0 group-hover:opacity-100">
                        double click to open
                    </span>
                </div>
            </div>

            <div className="p-2 flex-1">
                <div className="md:text-lg font-medium line-clamp-2">
                    {folder.name}
                </div>
            </div>
        </div>
    );
}

